module.exports = __webpack_public_path__ + "img/Map_Line_16px_Icon.834a3192.svg";